var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvoluxionSystemsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 18.5653,
    width: 7.43222,
    height: 11.5536,
    rx: 3.71611,
    fill: "#1B0B3B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.880981,
    width: 7.43222,
    height: 7.43222,
    rx: 3.71611,
    fill: "#1B0B3B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8138,
    y: 9.48193,
    width: 7.43222,
    height: 20.6369,
    rx: 3.71611,
    fill: "#1B0B3B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.6277,
    y: 0.880981,
    width: 7.43222,
    height: 29.2378,
    rx: 3.71611,
    fill: "#1B0B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvoluxionSystemsLogo);
export default __webpack_public_path__ + "static/media/Evoluxion-Systems-logo.7de7abf095d13587498ee399484e9acc.svg";
export { ForwardRef as ReactComponent };